export function emitWindowEvent(name: string, detail: any) {
  const customEvent = new CustomEvent(name, {
    detail
  });

  window.dispatchEvent(customEvent);
}
